const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiudad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g1277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1279",
    d: "M12.36,5.1c.75.96,1.07,2.35,1.07,3.95,0,3.1-1.28,5.45-4.38,5.45-1.5,0-2.46-.43-3.2-1.28,1.07-1.17,2.67-2.99,3.52-3.95.75-1.07,2.03-2.78,2.99-4.17Z",
    style: {
      fill: "#2350a9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1283",
    d: "M5.64,12.9c-.75-.96-1.07-2.35-1.07-3.84,0-3.2,1.28-5.55,4.49-5.55,1.28,0,2.35.53,3.1,1.28-1.17,1.28-2.78,3.1-3.42,3.95-.85.96-2.14,2.88-3.1,4.17Z",
    style: {
      fill: "#00adef"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiudad);
export default __webpack_public_path__ + "static/media/ciudad.dcd689fbdf41e07dab0ee05edd21a95e.svg";
export { ForwardRef as ReactComponent };